<!--
 * @Author: qinzhenpen qzp1807@126.com
 * @Date: 2023-09-28 14:48:30
 * @LastEditors: qinzhenpen qzp1807@126.com
 * @LastEditTime: 2024-09-11 14:38:42
 * @FilePath: \tianze_web\src\layout\components\Sidebar.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <ul>
      <li :class="onIndex == 0?'on':''" @click="jumpPage(0,'Home')">
        <router-link :to="{path:'Home'}">
          <el-image class="menu_img" :src="home_img"></el-image>
          <span>首页</span>
        </router-link>
      </li>
      <li :class="onIndex == 1?'on':''" @click="jumpPage(1,'MyApps',{type:'my'})">
        <router-link :to="{path:'MyApps',query:{type:'my'}}" >
          <el-image class="menu_img" :src="yingyong"></el-image>
          <span>我的应用</span>
        </router-link>
      </li>
      <li :class="onIndex == 2?'on':''" @click="jumpPage(2,$Base64.decode($ls.get($getKeyInfo('userType'))) == 1?'MyCourse':'TMyCourse')">
        <router-link :to="{path:$Base64.decode($ls.get($getKeyInfo('userType'))) == 1?'MyCourse':'TMyCourse'}" >
          <el-image class="menu_img" :src="kecheng"></el-image>
          <span>我的课程</span>
        </router-link>
      </li>
      <li :class="onIndex == 3?'on':''" @click="jumpPage(3,$Base64.decode($ls.get($getKeyInfo('userType'))) == 1?'UserCenter':'TUserCenter')">
        <router-link :to="{path:$Base64.decode($ls.get($getKeyInfo('userType'))) == 1?'UserCenter':'TUserCenter'}" >
          <el-image class="menu_img" :src="yonghu"></el-image>
          <span>用户中心</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import yonghu from '@/images/index/yonghu@2x.png';
import home_img from '@/images/index/shouye@2x.png';
import yingyong from '@/images/index/yingyong@2x.png';
import kecheng from '@/images/index/kecheng@2x(1).png';
export default {
    name: 'Sidebar',
  data() {
    return {
      onIndex:1,
      kecheng:kecheng,
      home_img:home_img,
      yingyong:yingyong,
      yonghu:yonghu,
    }
  },
  created() {

  },
  methods: {
    jumpPage(index,name,param){ //控制用户点击菜单显示
      this.onIndex = index;
      this.$router.push({name:name,query:param || {}});
      this.$emit('updateDate','sidebar');
    },
  }
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar.vue